import React, { Component, Fragment } from 'react';
import Helmet from 'react-helmet';
import styles from './styles.module.css';

import glassData from '../../../data/glassData.js';
import memoryData from '../../../data/memories.js';

import GridWrap from '../../components/grid-wrap';
import PillButton from '../../components/pill-button';
import SiteFooter from '../../components/site-footer';
import ContributionForm from '../../components/contribution-form';

import Header from './header';
import Gallery from './gallery';
import Description from './description';
import Memories from './memories';
import Related from './related';

import camelToDisplayText from '../../utils/camelToDisplayText';
import textMapping from '../../utils/textMapping';

const PageSection = ({ title, buttonText, buttonOnClick, children }) => (
  <section>
    {title && (
      <div className={styles.header}>
        <h2>{title}</h2>
        {buttonText && (
          <PillButton small text={buttonText} onClick={buttonOnClick} />
        )}
      </div>
    )}
    {children}
  </section>
);

export default class GlassDetail extends Component {
  state = {
    contributingOpen: false,
    contributingForm: null
  };

  openContributing = view =>
    this.setState({ contributingOpen: true, contributingForm: view });
  closeContributing = view =>
    this.setState({ contributingOpen: false, contributingForm: null });

  render() {
    const {
      pathContext: { id }
    } = this.props;
    const object = glassData.find(item => item.id === id);

    const attributes = object.data || {};
    const attributeNames = Object.keys(attributes);
    attributeNames.sort((a, b) => a.localeCompare(b));

    const images = object.images || [];

    const memories = memoryData
      .filter(memory => memory.relatedItems.includes(id))
      .map(memory =>
        Object.assign({}, memory, {
          relatedItems: memory.relatedItems.filter(
            relatedItem => relatedItem !== id
          )
        })
      )
      .sort((a, b) => a.submissionDate < b.submissionDate);

    return (
      <div className={styles.container}>
        <Helmet title={object.title} />
        <Header heading={object.title} />
        <GridWrap>
          <div style={{ width: '100%' }}>
            <div className={styles.topSection}>
              <div className={styles.topLhs}>
                <Gallery
                  itemId={id}
                  images={images}
                  addImage={() => this.openContributing('images')}
                  editImages={() => this.openContributing('editImages')}
                  title={object.title}
                />
              </div>
              <div className={styles.topRhs}>
                <dl>
                  {attributeNames.map(attributeName => (
                    <Fragment key={attributeName}>
                      <dt>{camelToDisplayText(attributeName)}</dt>
                      <dd>
                        {textMapping(attributeName, attributes[attributeName])}
                      </dd>
                    </Fragment>
                  ))}
                </dl>
              </div>
            </div>

            <PageSection title="About this item">
              <Description description={object.description} />
            </PageSection>

            <PageSection>
              <div className={styles.contributeCta}>
                <h2>Contribute</h2>
                <p>
                  If you have any additional information or images to contribute
                  for this item please do so using our contribution form! We'll
                  review your contribution and let you know when it has been
                  published.
                </p>
                <PillButton
                  text="Contribute"
                  onClick={() => this.openContributing(null)}
                />
              </div>
            </PageSection>

            {object.relatedItems.length > 0 && (
              <PageSection title="Related Items">
                <Related relatedItems={object.relatedItems} />
              </PageSection>
            )}

            <PageSection
              title="Memories"
              buttonText="Add a memory"
              buttonOnClick={() => this.openContributing('memory')}
            >
              <Memories memories={memories} />
            </PageSection>

            {this.state.contributingOpen && (
              <ContributionForm
                itemId={id}
                form={this.state.contributingForm}
                closeForm={this.closeContributing}
              />
            )}
          </div>
        </GridWrap>
        <SiteFooter />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/page-components/glass-detail/index.js